import React, { Fragment } from "react";
import nprogress from "nprogress";

import "nprogress/nprogress.css";

export default class NProgress extends React.Component {

  constructor(props) {
    super(props);
    nprogress.start();
  };

  componentWillUnmount() {
    nprogress.done();
  };

  render() {
    return <Fragment></Fragment>
  };
};
